// extracted by mini-css-extract-plugin
export default {"projects_bg":"Projects_projects_bg__ky+g+"};